import React, { useState } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../context-store";
import CompanyDashboardModel from "../../../models/company/dashboard/response/CompanyDashboardModel";
import IdNameModel from "../../../models/common/IdNameModel";
import companyClasses from "../../../landing-pages/company/company.module.css";
import JobPostingStatusUpdateModel from "../../../models/company/jobPosting/request/JobPostingStatusUpdateModel";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import toasterUtils from "../../../utils/toaster-utils";
import TablePagination from "@mui/material/TablePagination";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import ViewEscalationComponent from "../add-profiles/ViewEscalationComponent";
import modalUtils from "../../../utils/modal-utils";
import EscalationImg from "../../../assets/img/content/escalation.png";

interface JobPostingDashboardGridProps {
    jobPostingList: CompanyDashboardModel[];
    status: IdNameModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    escalationStatusList: IdNameModel[];
    onJobStatusChangeAction: (jobPosting: JobPostingStatusUpdateModel) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
};

const JobPostingDashboardGridComponent = (props: JobPostingDashboardGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [roleId, setRoleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const history = useHistory();

    const updateStatus = (requirementId: string, statusId: number) => {
        if (roleId === parseInt(RoleEnum.ClientRecruiter.toString()) || roleId === parseInt(RoleEnum.ClientLead.toString()) || roleId === parseInt(RoleEnum.ClientAdmin.toString())) {
            if (loggedInUser !== null) {
                let updateModel: JobPostingStatusUpdateModel = {
                    requirementId: requirementId,
                    statusId: statusId,
                    assignToId: GuidEnum.Empty,
                    comments: "",
                    userId: loggedInUser?.userId
                }
                props.onJobStatusChangeAction(updateModel);
            }
        } else {
            toasterUtils.showWarning("You Don't have permission to update.");
        }
    };

    const getStatusNameFromList = (statusId: number) => {
        let objStatus = props.status.find(x => x.id === statusId);
        if (objStatus !== null) {
            return objStatus?.name
        } else {
            return "";
        }
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const onViewEscalationsHandler = (requirementId: string) => {
        const config: GeneralPoupConfig = {
            title: "Escalations",
            content: (
                <ViewEscalationComponent
                    requirementId={requirementId}
                    statusList={props.escalationStatusList} />
            ),
            size: ModalSize.XL,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    return (
        <div className="row">
            {props.jobPostingList.map((posting: CompanyDashboardModel) => {
                return (
                    <div className="col-lg-6 col-md-6 posting-listings">
                        <div className="card card-white">
                            <div className="card-heading clearfix ">
                                <h4 className="card-title title-job">{posting.jobCode}
                                    {(roleId === parseInt(RoleEnum.ClientRecruiter.toString()) || roleId === parseInt(RoleEnum.ClientAdmin.toString()) || roleId === parseInt(RoleEnum.ClientLead.toString())) &&
                                        <a onClick={() => onViewEscalationsHandler(posting.requirementId)}> <img src={EscalationImg} className="esclation-link"/></a>
                                    }
                                </h4>
                            </div>
                            <div className="card-body" >
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="row mb-2">
                                            <div className="col-lg-4 col-md-4">
                                                <b>Posted by:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.postedBy}
                                            </div>

                                            <div className="col-lg-4 col-md-4">
                                                <b>Exp:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.experience}
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="row mb-2">
                                            <div className="col-lg-4 col-md-4">
                                                <b>Posted on:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value">
                                                {posting.postedDate}
                                            </div>

                                            <div className="col-lg-4 col-md-4">
                                                <b>Designation:</b>
                                            </div>
                                            <div className="col-lg-8 col-md-8 job-posting-value des-highlight">
                                                {posting.designationName}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="row mb-2">
                                            <div className="col-lg-2 col-md-2">
                                                <b>Skills:</b>
                                            </div>
                                            <div className="col-lg-10 col-md-10 job-posting-value">
                                                {posting.skills}
                                            </div>

                                            <div className="col-lg-2 col-md-2">
                                                <b>Status:</b>
                                            </div>
                                            <div className="col-lg-10 col-md-10 ">
                                                <a className={companyClasses.jobPostinglinks} onClick={() => updateStatus(posting.requirementId, posting.statusId)}>{getStatusNameFromList(posting.statusId)} <i className="fas fa-external-link-alt"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">

                                        {roleId === parseInt(RoleEnum.ClientRecruiter.toString()) &&
                                            <ul className="list-inline profile-link-list">
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/add-profiles/" + posting.requirementId)}> Add Profile</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/related-profiles/" + posting.requirementId)}> Related Profiles</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/applied-candidates/" + posting.requirementId)}> Applied Candidates</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/shortlisted-profiles/" + posting.requirementId)}> Shortlisted Profiles</a></li>
                                            </ul>
                                        }
                                        {roleId === parseInt(RoleEnum.VendorRecruiter.toString()) &&
                                            <ul className="list-inline profile-link-list">
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/add-profiles/" + posting.requirementId)}> Add Profile</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} > Related Profiles</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} > Applied Candidates</a></li>
                                                <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} > Shortlisted Profiles</a></li>
                                            </ul>
                                        }
                                        {(roleId === parseInt(RoleEnum.ClientAdmin.toString()) || roleId === parseInt(RoleEnum.ClientLead.toString())) &&
                                            <ul className="list-inline profile-link-list">
                                                {/* <li><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/add-profiles/" + posting.requirementId)}> Add Profile</a></li> */}
                                                <li className="three-colum"><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/related-profiles/" + posting.requirementId)}> Related Profiles</a></li>
                                                <li className="three-colum"><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/applied-candidates/" + posting.requirementId)}> Applied Candidates</a></li>
                                                <li className="three-colum"><i className="fas fa-angle-right"></i><a className={companyClasses.jobPostinglinks} onClick={() => history.push("/shortlisted-profiles/" + posting.requirementId)}> Shortlisted Profiles</a></li>
                                            </ul>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            })}
            <TablePagination
                rowsPerPageOptions={props.pageSizesList}
                component="div"
                count={props.totalSize}
                rowsPerPage={props.pagesize}
                page={props.currentPage - 1}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
};
export default JobPostingDashboardGridComponent;